// Import model
import { StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static deserialize(json: string): StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest');
    }


    const instance: StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentInitiateSmsForUpcomingApppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
